import { Box, Typography } from '@mui/material';
import { BlendCandidate, BlendSource } from '../adapters/types';
import {
    CANVAS_BG,
    HAIRLINE,
    TILE_RADIUS,
    READOUT_DIM,
    READOUT_FONT,
} from '../chrome';
import PairControl from './PairControl';

interface SecondaryImagePlaceholderProps {
    /** Per-row blend truth: the candidates this pane can draw. */
    readonly source: BlendSource;
    readonly onFuse: (candidate: BlendCandidate) => void;
    readonly onClear: () => void;
}

/**
 * The empty-secondary state: says the pane draws nothing, and carries the
 * row's own secondary-image picker, so the choice is offered where the gap
 * is. Never a passive blank.
 */
export default function SecondaryImagePlaceholder({
    source,
    onFuse,
    onClear,
}: SecondaryImagePlaceholderProps) {
    return (
        <Box
            data-testid="secondary-image-placeholder"
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                bgcolor: CANVAS_BG,
                border: '1px dashed',
                borderColor: HAIRLINE,
                borderRadius: TILE_RADIUS,
                color: READOUT_DIM,
                fontFamily: READOUT_FONT,
            }}
        >
            <Typography
                variant="caption"
                sx={{ color: READOUT_DIM, letterSpacing: 1, fontSize: 11 }}
            >
                No secondary image
            </Typography>
            <PairControl source={source} onFuse={onFuse} onClear={onClear} />
        </Box>
    );
}
